module.exports = __webpack_public_path__ + "public/images/partners/sup-11.0667adbed06bd1f01edb022b129c0f1c.png";